import { isBrowser } from './env.js';
import 'nanoid';
import 'timen';
import 'compareq';
import 'lodash.pick';
import './queryParams.js';

function getCoords(elem) {
    const box = elem.getBoundingClientRect();
    return {
        top: box.top + window.pageYOffset,
        left: box.left + window.pageXOffset,
    };
}
function hasParent(elem, parentElem) {
    const isEqual = elem === parentElem;
    if (isEqual || elem.nodeName === 'HTML') {
        return isEqual;
    }
    return hasParent(elem.parentNode, parentElem);
}
var INTERACTION_MODE;
(function (INTERACTION_MODE) {
    INTERACTION_MODE["POINTER"] = "pointer";
    INTERACTION_MODE["KEYBOARD"] = "keyboard";
})(INTERACTION_MODE || (INTERACTION_MODE = {}));
let interactionMode = INTERACTION_MODE.POINTER;
const getInteractionMode = () => interactionMode;
function watchControllerFlag() {
    const classes = document.body.classList;
    const onPointerMove = () => {
        classes.remove(INTERACTION_MODE.KEYBOARD);
        classes.add(INTERACTION_MODE.POINTER);
    };
    ['pointerdown', 'pointermove'].forEach(event => {
        document.addEventListener(event, onPointerMove, true);
    });
    document.addEventListener('keydown', () => {
        classes.remove(INTERACTION_MODE.POINTER);
        classes.add(INTERACTION_MODE.KEYBOARD);
    });
    classes.add(interactionMode);
}
const isTouch = () => isBrowser && 'ontouchstart' in window;

export { INTERACTION_MODE, getCoords, getInteractionMode, hasParent, isTouch, watchControllerFlag };
